import { Autocomplete, AutocompleteChangeReason, TextField } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store';
import { RoleAccess } from '../../../types/roles';

interface IRoleAutoCompleteProps {
    disableClearable: boolean;
    filterRole: string | undefined;
    setFilterRole: (bank: string | undefined) => void;
}

const RoleAutoComplete = ({ disableClearable, filterRole, setFilterRole }: IRoleAutoCompleteProps) => {
    const { t } = useTranslation();
    const userLoggedRole = useSelector((state: RootState) => state.auth.user?.roles?.[0].role);

    const [roleListOptions, setRoleListOptions] = useState<[] | { label: string; value: string }[]>([]);
    const [roleOptionSelected, setRoleOptionSelected] = useState<{ label: string; value: string } | null>(null);

    useEffect(() => {
        const arrayRoleOption: { label: string; value: string }[] = [];
        RoleAccess?.[userLoggedRole].map((role: string) => {
            arrayRoleOption.push({
                label: role,
                value: role
            });
            return arrayRoleOption;
        });

        setRoleListOptions(arrayRoleOption);
    }, []);

    useEffect(() => {
        if (!filterRole) setRoleOptionSelected(null);

        setRoleOptionSelected({
            label: filterRole,
            value: filterRole
        });
    }, [filterRole]);

    return (
        <Autocomplete
            disablePortal
            disableClearable={disableClearable}
            id="combo-box-role"
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={roleOptionSelected}
            onInputChange={(event: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteChangeReason) => {
                if (reason === 'clear') {
                    setFilterRole(undefined);
                    return;
                }
            }}
            inputValue={roleOptionSelected?.label || ''}
            options={roleListOptions}
            sx={{ width: '100%', minWidth: '140px' }}
            renderInput={(params) => <TextField {...params} label={t('role.label', { ns: 'common' })} InputLabelProps={{ shrink: true }} variant="standard" />}
            onChange={(event: SyntheticEvent<Element, Event>, value: { label: string; value: string } | null, _reason: AutocompleteChangeReason) => {
                setFilterRole(value?.value ?? undefined);
            }}
        />
    );
};

export default RoleAutoComplete;
